import React, { useCallback } from 'react'

import { renewal_status } from '../../../Configs/options'

import CheckboxEl from '@/Form/V2/Managed/CheckboxEl'

import Link  from '@Pure/Link'

import { isTrue } from '@root/utility'

import DashboardStore from '@Store/Dashboard'

const { app } = window;

const DASHBOARD = 'PartnersList';

export default function PartnerRow ({ data, blank=true, fields, ...props })
{
	let row_class = 'c-dashboard__row';

	const id = data.id;

	const is__checked = DashboardStore
	.useState(s => isTrue(s[DASHBOARD]?.cbs?.[id]));

	const toggleCB = useCallback(function (e, name)
	{
		DashboardStore.update(function (store)
		{
			store[DASHBOARD] ||= { };
			store[DASHBOARD].cbs ||= { };

			if (isTrue(store[DASHBOARD].cbs[id]))
			{
				delete store[DASHBOARD].cbs[id];
			}
			else
			{
				store[DASHBOARD].cbs[id] = true;
			}
		});
	},
	[id]);

	const blank_props = blank === true
	? { target: '_blank', rel: 'noopener noreferrer' }
	: { };

	const link =
	(
		<Link className="u-link-only" { ...blank_props }
			href={ '/partenaires/' + data.id }>
			<span className="u-readers-only">
				Voir l'enseigne
			</span>
		</Link>
	);

	return (
		<div className={ row_class }>

			{
				fields.includes('_checkbox') ?
				(
					<div className="c-dashboard__cell Partner-_checkbox">

						<CheckboxEl name="enabled"
							checked={ is__checked }
							onChange={ toggleCB }
							bemit={ ['in-cell'] }
						/>

					</div>
				)
				: undefined
			}

			<div className="c-dashboard__cell Partner-name">

				<div className="c-dashboard__long-text">
					{ data.name }
				</div>

				{ link }

			</div>

			<div className="c-dashboard__cell Partner-category">
				{ data._category?.name }

				{ link }
			</div>

			<div className="c-dashboard__cell Partner-phone">
				{ data.phone }

				{ link }
			</div>

			<div className="c-dashboard__cell Partner-city">
				{ data.city }

				{ link }
			</div>

			<div className="c-dashboard__cell Partner-highlighted">
				{ isTrue(data.highlighted) ? 'Oui' : 'Non' }

				{ link }
			</div>

			<div className="c-dashboard__cell Partner-renewal">
				<div className={ 'partner-renewal-status ' +
					(data.renewal?.status || 'none') }>
					{ renewal_status[data.renewal?.status || 'none'] }
				</div>
			</div>

			<div className="c-dashboard__cell Partner-actions">
				<button className="c-btn c-btn--smaller u-no-margins"
					type="button" onClick={ function (e)
						{
							app.emit('open__PartnerRenewalModal',
							{
								partner: data
							});
						} }>
					+ Détails
				</button>
			</div>

		</div>
	);
}